<template>
  <div>
    <el-alert
      :title="feedback"
      type="warning"
      v-show="showFeedback"
      effect="dark"
      description="请您按照退回意见，单击[我要编辑]，进行修改提交。"
      show-icon
    ></el-alert>
    <el-card>
      <div slot="header" class="clearfix">
        <span>1、我的信息</span>
        <span v-show="!showAddBtn">
            <el-button
              type="text"
              class="edit-button"
              icon="el-icon-edit"
              @click="handleEdit"
              v-if="info.editable"
            >
              我要编辑
            </el-button>
            <el-button
              type="text"
              class="edit-button"
              v-else
              @click="handleView"
            >
              我要查看
            </el-button>
            <el-button
              type="text"
              class="edit-button"
              icon="el-icon-tickets"
              v-show="showLogBtn"
              @click="handleLog"
            >
              流程日志
            </el-button>
        </span>
        <oper-log ref="OperLog"></oper-log>
      </div>
      <el-row>
        <el-col :span="24" :offset="11">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="handleEdit"
            v-show="showAddBtn"
          >
            我要填写信息
          </el-button>
        </el-col>
        <!-- <el-col :span="6"> 放一寸照片 </el-col> -->
        <el-col :span="24" v-show="!showAddBtn">
          <el-descriptions :column="2" :contentStyle="{ height: '33px' }">
            <el-descriptions-item label="专家编号">
              {{ info.mavinNo }}
            </el-descriptions-item>
            <el-descriptions-item label="姓名">
              <a :href="url" target="edit">{{ info.mavinName }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="身份证号码">
              {{ info.safeIdCard }}
            </el-descriptions-item>
            <el-descriptions-item label="基层工作单位" span="2">
              {{ info.deptName }}
            </el-descriptions-item>
            <el-descriptions-item label="单位所在地">
              <el-tag size="small">{{ info.areaName }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="现任职称">
              {{ info.levelName }} - {{ info.appellation }}
            </el-descriptions-item>

            <el-descriptions-item label="可评审专业1">
              {{ info.allSpeName1 }}
            </el-descriptions-item>
            <el-descriptions-item label="可评审专业2">
              {{ info.allSpeName2 }}
            </el-descriptions-item>
            <el-descriptions-item label="可评审专业3">
              {{ info.allSpeName3 }}
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-button
                type="text"
                class="edit-button"
                @click="handleLog"
                v-text="info.stateName"
              ></el-button>
            </el-descriptions-item>
            <el-descriptions-item label="新增时间">
              <span>
                {{ moment(info.addTime).format('YYYY-MM-DD HH:mm:ss') }}
              </span>
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getHome } from '@/api/home/front.js';
import OperLog from '@/components/OperLog/Index.vue';

export default {
  data() {
    return {
      info: {},
      url: '/mavin/guide/base',
      feedback: ''
    };
  },
  components: {
    OperLog
  },
  computed: {
    showLogBtn() {
      return this.info && this.info.mavinEid;
    },
    showFeedback() {
      return this.feedback && this.info.feedback;
    },
    showAddBtn() {
      return this.info && !this.info.mavinEid;
    }
  },
  methods: {
    handleEdit() {
      this.$alert('我已编辑完成!请单击确定。', '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          this.get();
        }
      });

      if (this.info.mavinEid) {
        window.open(this.url + '/' + this.info.mavinEid, 'MavinEdit');
      } else {
        window.open(this.url, 'MavinEdit');
      }
    },
    handleView() {
      window.open('/mavin/review/' + this.info.mavinEid, 'MavinEdit');
    },
    handleLog() {
      if (this.showLogBtn) {
        this.$refs.OperLog.show('MavinBase', this.info.mavinEid);
      } else {
        alert('请您填写信息');
      }
    },
    get() {
      getHome().then(res => {
        if (res) {
          this.info = res;
          this.feedback = res.feedback;
        }
      });
    }
  },
  created() {
    this.get();
  }
};
</script>

<style lang="scss" scoped>
.edit-button {
  float: right;
  padding: 3px 0 0 10px;
  font-size: 14px;
}
</style>
